import React, { useState } from "react";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { SubCard } from "../../common_components/Layout";
import XIcon from "../../../../../../../assets/images/researcher_app/create/x_button.svg";
import UserIcon from "../../../../../../../assets/images/researcher_app/create/create_attendee_icon.png";
import TrashIcon from "../../../../../../../assets/images/researcher_app/create/create_trash_icon.png";
import { BareTextField } from "../../common_components/Forms";
import { SecondaryButton } from "../../common_components/Buttons";
import { useAlert } from 'react-alert'


function MissionAttendeesForm(props) {

    return (
        <div className="attendees-div">
            <div className="create-attendees-title-and-subtitle-div">
                <div className="researcher-label-and-tooltip-div">
                    <label className="researcher-label">Invite colleagues</label>
                    {/* <img className="px-2" src={InfoIcon} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={props.tooltip} /> */}
                </div>
                <div className="attendees-subtitle-text" >
                    Add your colleagues to send them calendar invites for research sessions. They will receive invites and session updates, but will not be invited to this platform.                </div>
            </div>
            <div className="attendees-form-wrapper">
                <ExistingAttendees attendees={props.attendees} deleteAttendee={props.deleteAttendee} />
                <AddAttendeeForm addAttendee={props.addAttendee} />
            </div>
        </div>
    )

}

function ExistingAttendees(props) {
    return (
        <div className="existing-attendees-wrapper">
            {props.attendees.map((attendee, index) => (
                <ExistingAttendee key={index} attendee={attendee} className="existing-attendee" deleteAttendee={props.deleteAttendee} />
            ))}
            <div className="horizontal-attendee-divider" />
        </div>
    )
}

function ExistingAttendee(props) {
    const attendeeName = `${props.attendee.first_name} ${props.attendee.last_name}`

    return (
        <div className="existing-attendee-wrapper">
            <div className="existing-attendee-minus-trash-icon-div">
                <img src={UserIcon} width={34} height={34} />
                <div className="existing-attendee-text">
                    {attendeeName}
                </div>
                <div className="attendee-divider" />
                <div className="existing-attendee-text">
                    {props.attendee.email}
                </div>
            </div>

            {props.attendee.removable &&
                <div className="existing-attendee-delete" onClick={() => props.deleteAttendee(props.attendee.id)}>
                    <img src={TrashIcon} height={20} width={20} />
                </div>
            }
        </div>
    )
}


function AddAttendeeForm(props) {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");

    const alert = useAlert();

    // This one vets out that the input is proper - specifically the email
    // Then it calls the addAttendee function from the parent component
    function submitAddAttendee() {
        if (!firstName) { alert.show("Please enter a first name", { type: 'error' }); return; }
        if (!email || !validateEmail(email)) { alert.show("Please enter a valid email address", { type: 'error' }); return; }

        // Submit and reset
        props.addAttendee({ first_name: firstName, last_name: lastName, email: email });
        setFirstName("");
        setLastName("");
        setEmail("");


    }

    function validateEmail(email) {
        const regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,61}$/;
        return regex.test(email);
    }

    function submitHandler(e) {
        e.preventDefault();
        submitAddAttendee
    }

    return (
        <form className="div-with-label-wrapper" onSubmit={submitHandler}>
            <div className="researcher-label">Add Attendee</div>
            <div className="new-attendee-wrapper">
                <div className="new-attendee-input-wrapper">
                    <BareTextField name="first_name" id="first_name" placeholder="First name" value={firstName} onChange={(event) => setFirstName(event.target.value)} />
                    <BareTextField name="last_name" id="last_name" placeholder="Last name" value={lastName} onChange={(event) => setLastName(event.target.value)} />
                    <BareTextField name="email" id="email" size="large" placeholder="Email" value={email} onChange={(event) => setEmail(event.target.value)} />
                </div>
                <div className="new-attendee-button-wrapper">
                    <SecondaryButton onClick={submitAddAttendee} text="Add" />
                </div>
            </div>
        </form>
    )
}

export default MissionAttendeesForm;